import { render, staticRenderFns } from "./NeedsYourApproval.vue?vue&type=template&id=0f4f0d8a"
import script from "./NeedsYourApproval.vue?vue&type=script&lang=js"
export * from "./NeedsYourApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports